import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const sections = [
  {
    title: "Workspace",
    links: [
      { to: "/", label: "Dashboard", icon: "bi-grid-1x2-fill" },
      { to: "/workplan-gantt", label: "Workplan Gantt", icon: "bi-bar-chart-steps" },
      { to: "/activities", label: "Activities", icon: "bi-calendar2-week-fill" }
    ]
  },
  {
    title: "Staff Tasks",
    links: [
      { to: "/staff-tasks", label: "Staff Tasks", icon: "bi-list-check" },
      { to: "/travel-requests", label: "Out of Office", icon: "bi-briefcase-fill" },
      { to: "/pm-visitor-logs", label: "PM Engagement log", icon: "bi-journal-text" },
      { to: "/documents", label: "Documents Management", icon: "bi-folder2-open" }
    ]
  },
  {
    title: "Settings",
    className: "sidebar-section-settings",
    links: [
      { to: "/users", label: "Users", icon: "bi-person-badge-fill" },
      { to: "/grants", label: "Grants", icon: "bi-bank2" },
      { to: "/pillars", label: "Pillars", icon: "bi-diagram-3-fill" },
      { to: "/implementors", label: "Implementors", icon: "bi-people-fill" }
    ]
  }
];

function Sidebar({ open, onClose }) {
  const { user } = useAuth();
  const role = user?.role || "";
  const isRestrictedRole = useMemo(() => ["staff", "supervisor"].includes(role), [role]);
  const visibleSections = useMemo(
    () =>
      sections
        .filter((section) => !(isRestrictedRole && section.title === "Settings"))
        .map((section) => ({
          ...section,
          links: section.links.filter((link) => !(isRestrictedRole && link.to === "/pm-visitor-logs"))
        })),
    [isRestrictedRole]
  );

  return (
    <>
      <div className={`sidebar-backdrop ${open ? "show" : ""}`} onClick={onClose} />
      <aside className={`app-sidebar ${open ? "show" : ""}`}>
        <nav className="sidebar-nav">
          {visibleSections.map((section) => (
            <div key={section.title} className={`sidebar-section ${section.className || ""}`}>
              <div className="sidebar-section-title">{section.title}</div>
              <div className="sidebar-section-links">
                {section.links.map((link) => (
                  <NavLink
                    key={link.to}
                    exact={link.to === "/"}
                    to={link.to}
                    className="sidebar-link"
                    activeClassName="active"
                    onClick={onClose}
                  >
                    <i className={`bi ${link.icon}`} />
                    <span>{link.label}</span>
                  </NavLink>
                ))}
              </div>
            </div>
          ))}
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
